import { Button } from '@/components/ui';
import { makeRequest } from '@/services/makeRequest';
import showToast from '@/components/toast/Toast';
import useLadyService from '@/services/LadyService';
import { Popup } from '../index';
import {
	getActivateProfileStatus,
	setActivateProfileStatus,
} from '@/stores/slices/popupSlice';
import {
	getProfileStatus,
	setProfileStatus,
} from '@/stores/slices/userProfileSlice';
import { useSelector } from 'react-redux';

const ActivateProfilePopup = () => {
	const { t, dispatch } = useLadyService();
	const profileStatus = useSelector(getProfileStatus);

	const open = useSelector(getActivateProfileStatus);

	const handleCloseDelete = () => {
		dispatch(setActivateProfileStatus(false));
	};

	const onSubmit = (e) => {
		e.preventDefault();

		const fetchData = async () => {
			try {
				const route = `user/set-profiles-status`;
				const method = 'PUT';
				const payload = {
					status: !profileStatus,
				};

				await makeRequest({ route, method, payload });

				dispatch(setProfileStatus(!profileStatus));

				handleCloseDelete();

				showToast({
					message: t('success'),
					variant: 'success',
				});
			} catch (error) {
				showToast({
					message: t('oops'),
					variant: 'error',
				});
			}
		};

		fetchData();
	};

	return (
		<Popup
			open={open}
			setOpen={handleCloseDelete}
			clazz={'gap-16'}
			id={'activateProfile'}
			container={'div'}
		>
			<h2>{profileStatus ? t('realywant') : t('activatepro')}</h2>

			{profileStatus ? (
				<div className="popup-form__inner text-center">
					<span className={'color-700'}>{t('alladsdeactivate')}</span>
				</div>
			) : (
				<></>
			)}

			<div className="popup-form__buttons">
				<Button
					// size={"l"}
					clazz={`${
						profileStatus ? 'button--green' : 'button--secondary'
					} justify-center`}
					onClick={handleCloseDelete}
				>
					{t('cancel')}
				</Button>

				<Button
					// size={"l"}
					buttonType={'submit'}
					clazz={`${
						profileStatus ? 'button--error' : 'button--green'
					} justify-center`}
					onClick={onSubmit}
				>
					{t('yes')}
					{profileStatus ? <>, {t('deactivate')}</> : <></>}
				</Button>
			</div>
		</Popup>
	);
};

export default ActivateProfilePopup;
